// extracted by mini-css-extract-plugin
export default {"modal":"ShareModal_modal__SXdUy","tabs":"ShareModal_tabs__C1s2p"};